/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var totalGivenCreditsAmountColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px',
  sm: true
}, {
  name: 'Главници',
  render: function render(_ref) {
    var total_amount_to_be_received_from_client = _ref.total_amount_to_be_received_from_client,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_amount_to_be_received_from_client"
    }, total_amount_to_be_received_from_client, " ", currency);
  }
}, {
  name: 'Лихви',
  render: function render(_ref2) {
    var total_interests = _ref2.total_interests,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_interests"
    }, total_interests, " ", currency);
  },
  md: true
}, {
  name: 'Такси',
  render: function render(_ref3) {
    var total_fees = _ref3.total_fees,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_fees"
    }, total_fees, " ", currency);
  },
  md: true
}, {
  name: 'Сума',
  render: function render(_ref4) {
    var total = _ref4.total,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_amount"
    }, total, " ", currency);
  }
}, {
  name: 'Просрочени главници',
  render: function render(_ref5) {
    var total_late_principals = _ref5.total_late_principals,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_principals"
    }, total_late_principals, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Просрочени лихви',
  render: function render(_ref6) {
    var total_late_interests = _ref6.total_late_interests,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_interests"
    }, total_late_interests, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Просрочени такси',
  render: function render(_ref7) {
    var total_late_fees = _ref7.total_late_fees,
        currency = _ref7.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_fees"
    }, total_late_fees, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо просрочие',
  render: function render(_ref8) {
    var total_late = _ref8.total_late,
        currency = _ref8.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late"
    }, total_late, " ", currency);
  },
  invisibleBelow: 3000
}];